<template>
  <v-list-group value="language">
    <template #activator="{ props }">
      <v-list-item v-bind="props">
        <v-list-item-title
          ><v-icon>mdi-web</v-icon>
          {{ t(`app.languages.${getLocaleName(locale).toLowerCase()}`) }}</v-list-item-title
        >
      </v-list-item>
    </template>

    <v-list-item
      v-for="lang in Object.values(Locale)"
      :key="lang"
      :append-icon="locale === lang ? 'mdi-check' : undefined"
      class="py-4"
      link
      @click="updateLocale(lang)"
    >
      <v-list-item-title>{{
        t(`app.languages.${getLocaleName(lang).toLowerCase()}`)
      }}</v-list-item-title>
      <v-list-item-subtitle>{{ getLocaleName(lang) }}</v-list-item-subtitle>
    </v-list-item>
  </v-list-group>
</template>

<script setup lang="ts">
import { Locale } from "@tableyeti/merchant-service";
import { useI18n } from "vue-i18n";
import { useLocale } from "@/composables/useLocale";

const { t } = useI18n();
const { locale, updateLocale, getLocaleName } = useLocale();
</script>
